export default __webpack_public_path__ + "static/media/x-mini.7b050cac.svg";